import React from 'react';
import PropTypes from 'prop-types';
import FormikAutocomplete from './FormikAutocomplete';

import ServiceService from 'services/ServiceService';

function ServiceAutocomplete({ getSuggestionLabel, ...others }) {
  const handleSearchTerm = (inputValue, setIsLoading) => {
    setIsLoading(true);
    return ServiceService.search(inputValue)
      .then((data) => {
        return data;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <FormikAutocomplete
      onChangeSearchTerm={handleSearchTerm}
      getSuggestionLabel={getSuggestionLabel}
      placeholder="Selectione..."
      {...others}
    />
  );
}

ServiceAutocomplete.defaultProps = {
  getSuggestionLabel: (object) => {
    return object.name;
  },
  onChange: () => {},
};
ServiceAutocomplete.propTypes = {
  getSuggestionLabel: PropTypes.func,
  onChange: PropTypes.func,
};
export default ServiceAutocomplete;
